import Vue from 'vue'

import texts from '@/components/atoms/text'
import atomTime from '@/components/atoms/a-time'

Vue.component('texts', texts)
Vue.component('a-time', atomTime)
